export const customStyles = {
    rows: {
        style: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            width: '100%',
            minHeight: '60px', // override the row height
        }
    },
    headCells: {
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
            paddingLeft: '20px', // override the cell padding for head cells
            paddingRight: '20px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
        },
    },
    bodyCells: {
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
            paddingLeft: '20px',
            paddingRight: '20px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
        },
    },
    cells: {
        style: {
            fontSize: '13px',
            paddingLeft: '20px', // override the cell padding for data cells
            paddingRight: '20px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
        },
    },
    dataCells: {
        style: {
            fontSize: '14px',
            paddingLeft: '20px', // override the cell padding for data cells
            paddingRight: '20px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
        },
    },
    dataRow: {
        style: {
            fontSize: '14px',
            paddingLeft: '20px', // override the cell padding for data cells
            paddingRight: '20px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
        },
    },
    pagination: {
        style: {
            fontSize: '14px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
        },
    },
};
